import { render, staticRenderFns } from "./InfoCards.vue?vue&type=template&id=61bdea74"
import script from "./InfoCards.vue?vue&type=script&lang=js"
export * from "./InfoCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports